import React, { Fragment } from 'react';
import TargetLabelDashboard from './TargetLabelDashboard';

const LabelView = () => {
  return (
    <Fragment>
      <TargetLabelDashboard />
    </Fragment>
  );
};

LabelView.propTypes = {};

export default LabelView;
